import script from "./ImportQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportQuestions.vue?vue&type=script&setup=true&lang=js"

import "./ImportQuestions.vue?vue&type=style&index=0&id=6ef052a6&lang=less"

const __exports__ = script;

export default __exports__